// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: a ClickUp task as the context of a new coding-agent chat ("Send to an agent").

import type {AgentChatContext} from '@app/features/konvo_agents/state/AgentsModel';
import type {KonvoTask} from '@app/features/konvo_tasks/state/KonvoTasks';
import {msg} from '@lingui/core/macro';

export const SEND_TO_AGENT_DESCRIPTOR = msg({
	message: 'Send to an agent',
	comment: 'Task detail menu item: start a coding-agent chat (Agents) with this ClickUp task as context.',
});

/** The task as a coding agent's context: its name, where it lives, the link and the description. */
export function taskAgentContext(task: KonvoTask): AgentChatContext {
	const where = [task.space?.name, task.folder?.name, task.list?.name].filter(Boolean).join(' / ');
	const text = [task.name, where, task.url, task.description?.trim()].filter(Boolean).join('\n\n');
	return {
		kind: 'task',
		label: task.custom_id ? `${task.custom_id} · ${task.name}` : task.name,
		text,
		hints: [task.list?.name ?? '', task.folder?.name ?? '', task.space?.name ?? '', task.name],
		// Kept with the chat: its agent time belongs to this task (Time and client).
		...(task.id && /^[A-Za-z0-9_-]{1,60}$/.test(task.id)
			? {source: {kind: 'task' as const, taskId: task.id, name: task.name.slice(0, 500), text: ''}}
			: {}),
	};
}
